(() => {
  const accordions = new WeakMap();
  function accordion(details) {
    const summary = details.querySelector('summary');
    let animation;
    let expanded = details.open;
    function setExpanded(open) {
      expanded = open;
      const start = details.getBoundingClientRect().height;
      animation?.cancel();
      animation = null;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        details.open = open;
        return;
      }
      details.open = true;
      const end = open ? details.scrollHeight : summary.getBoundingClientRect().height;
      animation = details.animate({height: [start + 'px', end + 'px']}, {duration: 400, easing: 'cubic-bezier(.16,1,.3,1)'});
      animation.onfinish = () => { details.open = open; animation = null; };
    }
    accordions.set(details, () => { if (expanded) setExpanded(false); });
    summary.addEventListener('click', event => {
      event.preventDefault();
      if (!expanded) {
        const group = details.closest('[data-article-faqs]');
        group.querySelectorAll('.blFaqItem').forEach(other => {
          if (other !== details) accordions.get(other)?.();
        });
      }
      setExpanded(!expanded);
    });
  }
  if (!customElements.get('ll-article')) customElements.define('ll-article', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const commentForm = this.querySelector('#comments form');
      if (commentForm) commentForm.addEventListener('formdata', event => {
        const website = commentForm.querySelector('[data-comment-website]').value.trim();
        if (website) event.formData.set('comment[body]', event.formData.get('comment[body]') + '\n\nWebsite: ' + website);
      });
      const source = this.querySelector('[data-article-faqs] .metafield-rich_text_field');
      if (source) {
        let answer;
        [...source.children].forEach(node => {
          if (node.tagName === 'H2') {
            const details = document.createElement('details');
            details.className = 'blFaqItem';
            const summary = document.createElement('summary');
            const marker = document.createElement('i'); marker.setAttribute('aria-hidden','true');
            node.before(details); summary.append(node,marker); details.append(summary);
            answer = document.createElement('div'); answer.className = 'blFaqItem__a'; details.append(answer);
          } else if (answer) answer.append(node);
        });
      }
      this.querySelectorAll('[data-article-faqs] .blFaqItem').forEach(accordion);
      this.querySelectorAll('.blCopyLink').forEach(button => button.addEventListener('click', async () => {
        const status = this.querySelector('.blToast');
        try { await navigator.clipboard.writeText(document.querySelector('link[rel="canonical"]')?.href || location.href.split('#')[0]); status.textContent = 'Link copied'; }
        catch { status.textContent = 'Copy the address bar to share'; }
        status.classList.add('on'); clearTimeout(this.timer); this.timer = setTimeout(()=>status.classList.remove('on'),2600);
      }));
      const dialog = this.querySelector('dialog');
      if (dialog) {
        const zoom = this.querySelector('.blZoom');
        const open = () => dialog.showModal();
        zoom.addEventListener('click',open);
        this.querySelector('.blHeroImg').addEventListener('click',open);
        dialog.querySelector('button').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
        dialog.addEventListener('close',()=>zoom.focus());
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
})();
